module.exports = __webpack_public_path__ + "static/media/Energiswap.cb7f46aa.svg";